import type { CustomAttributeFields } from "@jti/evo-client";
import type { CustomAttributeDefinition } from "@jti/fe-common";

export const prepareEvoCustomAttributes = (
  customAttributes: Record<string, CustomAttributeFields> = {}
): CustomAttributeDefinition[] => {
  return Object.entries(customAttributes).map(([customAttributeCode, properties]): CustomAttributeDefinition => ({
    hint: properties.hint || null,
    type: properties.type ?? "",
    label: properties.label || null,
    // in EVO types we have behaviour as an array of strings bun in frontend we expect "editable" | "readonly" | "hidden"
    // so we need to align with BE regarding expected values
    behaviour: (properties.behaviour as CustomAttributeDefinition["behaviour"]) || [],
    validation: properties.validation || null,
    display_after: properties.display_after || null,
    is_required: properties.is_required || false,
    is_address_field: properties.is_address_field,
    clearable: properties.clearable,
    code: customAttributeCode,
    // @ts-expect-error @TODO: remove this comment once API is updated https://jira.jtiweb.co.uk/browse/DESP-117442
    valid_values: properties.valid_values || null,
  }));
};
